//NPM LIBRARIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import AUdirectionLink from '@gov.au/direction-links';
import axios from 'axios';

//REDUX ACTIONS AND SELECTORS
import { getFormPropertiesSelector, getFormDataSelector } from '../../FormStore/Selectors/FormDataSelectors'
import { addFormComplete } from '../../FormStore/Actions/FormPropertyAction/FormPropertyAction';
import { addPageAlert, clearPageAlert } from '../../PortalStore/Actions/PageAlertActions';
import { saveDraft, SAVE_DRAFT_SUCCESS } from '../../FormStore/Actions/FormServiceActions/GenericFormServiceActions/SaveDraftAction';
import { addStepData, addStepDataPromise, setCurrentStep } from '../../FormStore/Actions/FormDataActions/GenericFormDataAction';

//COMPONENTS AND UTILITIES
import { validateStep, validateSerialNumber } from '../CASAForm/Utilities';
import StepNavigation from './StepNavigation';
import CASASpinner from '../Portal/CASASpinner';
import Question from './Question';

import DraftManagement from './DraftManagement';
import { ExitModal } from '../CASAForm/ExitModal';

const QuestionType = (<Question />).type;

class Step extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            redirectHome: false,
            applicationSubmitting: false,
            showError: false,
            stepId: props.id,
            questions: {},
            dirty: false,
            url: ''
        }
    }

    clickListener = (e) => {
        //if dirty show dialog box
        //if showing hide and bubble
        if (this.state.dirty && !this.state.modal) {
            e.preventDefault();
            this.setState({ url: e.target.getAttribute('href'), modal: true });
        }
        //if user cancels exit then hide dialog box and exit
        //if user oks exit then hide dialog box and bubble
    }

    cleanup = () => {
        document.querySelectorAll('a').forEach(item => {
            item.removeEventListener('click', this.clickListener);
        })
        window.removeEventListener("beforeunload", this.cleanup);
    }

    componentDidUpdate(prevProps) {
        window.addEventListener("beforeunload", this.cleanup);
        document.querySelectorAll('a').forEach(item => {
            item.addEventListener('click', this.clickListener);
        })
    }

    scrollTop = () => {
        window.scrollTo(0, 0);
    }

    nextStep = (e) => {
        e.preventDefault();
        this.scrollTop();

        let stepErrorMessage = validateStep(this.state.questions)
        let validateStepErrorMessage = ''

        if (this.props.validate) {
            validateStepErrorMessage = this.props.validate(this.state.questions);
        }

        if (!stepErrorMessage && !validateStepErrorMessage) {
            this.props.dispatch(addStepData({
                stepid: this.props.id,
                name: this.props.stepTitle,
                questions: this.state.questions
            }))

            this.props.dispatch(setCurrentStep(this.props.id))

            this.setState({ showError: false })
            this.props.dispatch(clearPageAlert());
            this.props.nextStep(this.props.id, 'next');

        } else if (stepErrorMessage || validateStepErrorMessage) {
            this.setState({ showError: true })
            this.props.dispatch(addPageAlert({
                level: 'error',
                title: 'There was a problem with the form',
                message: 'Please check the form below and try again'
            }));
        }
    }

    prevStep = (e) => {
        e.preventDefault();
        this.scrollTop();
        this.props.dispatch(clearPageAlert());
        this.props.nextStep(this.props.id, 'previous');
    }

    //hide if first step
    showPrev = () => {
        if (this.props.showback && !this.props.initialStep) {
            return (
                <AUdirectionLink
                    id="prevStep"
                    onClick={this.prevStep}
                    text="Back"
                    direction="left" />
            );
        }
        else {
            return null;
        }
    }

    showPrevPage = () => {
        if (this.props.showback && this.props.initialStep) {
            return (
                <AUdirectionLink
                    link={this.props.backurl}
                    linkComponent='a'
                    id="prevPage"
                    //onClick={this.toggle}
                    text="Back"
                    direction="left" />
            );
        }
        else {
            return null;
        }
    }

    setDirty = () => {
        this.setState({ dirty: true });
    }

    getPortalUrl = () => {
        if (this.props.envdata.items.systemsettings) {
            let portalSetting = this.props.envdata.items.systemsettings.value.find(systemSetting => systemSetting.casa_name === 'Portal - Home URL');
            let portalReturnUrl = null;
            if (this.props.formStore.formProperties.orgid === null || this.props.formStore.formProperties.orgid === "") {
                portalReturnUrl = portalSetting.casa_stringvalue + '/dashind';
            }
            else {
                portalReturnUrl = portalSetting.casa_stringvalue + '/dashorg/?casaorgid=' + this.props.formStore.formProperties.orgid;
            }
            return portalReturnUrl;
        }
    }

    onSubmitClick = (e) => {
        e.preventDefault();
        window.scrollTo(0, 0);

        let stepErrorMessage = validateStep(this.state.questions);

        if (!stepErrorMessage && this.props.validate) {
            stepErrorMessage = this.props.validate(this.state.questions);
        }
        if (stepErrorMessage && this.props.validate) {
            this.props.validate(this.state.questions);
        }

        if (!stepErrorMessage) {
            this.props.dispatch(addStepData({
                stepid: this.props.id,
                name: this.props.stepTitle,
                questions: this.state.questions
            }))

            this.setState({ showError: false })
            this.props.dispatch(clearPageAlert());
            this.props.dispatch(addFormComplete());

        } else if (stepErrorMessage) {
            this.setState({ showError: true })
            this.props.dispatch(addPageAlert({
                level: 'error',
                title: 'There was a problem with the form',
                message: 'Please check the form below and try again'
            }));
        }
    }

    addQuestionDataToState = (questionObject) => {

        let questions = this.state.questions;
        questions[questionObject.id] = questionObject;

        this.setState({
            questions: questions,
            dirty: true
        })
    };

    removeQuestionDataFromState = (questionId) => {
        let updatedQuestions = this.state.questions

        if (updatedQuestions) {
            delete updatedQuestions[questionId]
        }
    }

    saveDraft = () => {
        this.setState({ savingApplication: true });

        axios.all([
            this.props.dispatch(addStepDataPromise(this.props.id, this.props.stepTitle, this.state.questions))
        ])
            .then(() => {
                if (this.props.saveDraft) {
                    this.props.saveDraft();
                }
                else {
                    const webappurlForms = this.props.B2CSettings.items.webappurlFormsApi;
                    this.props.dispatch(saveDraft(webappurlForms, this.props.B2CSettings.items.accesstokenForms, this.props.formStore.formProperties, this.props.formStore.formData.genericFormData))
                        .then(response => {
                            if (response.type === SAVE_DRAFT_SUCCESS) {
                                this.setState({ savingApplication: false });
                                window.location.href = this.props.formStore.formProperties.draftReturnUrl + "&saveSuccess=1";
                            } else {
                                this.setState({ savingApplication: false });
                                this.props.dispatch(addPageAlert({
                                    level: "error",
                                    title: "Something has gone wrong",
                                    message: "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk."
                                }));
                            }
                        });
                }
            });
    }

    toggle = (e) => {
        e.preventDefault();

        this.setState({ modal: !this.state.modal });
    }

    //when user confirms exit then return to url in clicked link
    OK = (e) => {
        e.preventDefault();

        this.setState({ modal: !this.state.modal });

        if (location) {
            location.href = this.state.url;
        }
    }

    render() {

        let exitModalParams = {
            isOpen: this.state.modal,
            toggleFunction: this.toggle,
            OKFunction: this.OK
        }

        return (
            <div id={this.props.id}>
                <ExitModal exitModalParams={exitModalParams} />

                {this.state.applicationSubmitting ? <CASASpinner message="submitting..." /> : ''}
                {this.showPrevPage()}
                {this.showPrev()}
                <h2>{this.props.stepTitle}</h2>

                {React.Children.map(this.props.children, child => {
                    if (child.type === QuestionType) {
                        return React.cloneElement(child, {
                            returnQuestionData: this.addQuestionDataToState,
                            removeQuestionData: this.removeQuestionDataFromState,
                            showError: this.state.showError,
                            setDirty: this.setDirty
                        })
                    } else {
                        return child
                    }

                })}

                <div className="form-controls au-form-group">
                    {this.props.hasStepNavigation && <StepNavigation
                        type={this.props.isLastStep ? 'submit' : 'next'}
                        action={this.props.isLastStep ? this.onSubmitClick : this.nextStep}
                        label={this.props.isLastStep ? this.props.submitText : this.props.nextText} />}

                    {this.props.showDraftMangement &&
                        <DraftManagement
                            saveDraft={this.saveDraft} />}
                </div>
            </div>
        )
    }
}

Step.propTypes = {
    id: PropTypes.string.isRequired,
    stepTitle: PropTypes.string,
    validate: PropTypes.func,
    dispatch: PropTypes.func,
    isLastStep: PropTypes.bool,
    initialStep: PropTypes.bool,
    nextStep: PropTypes.func,
    showback: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    envdata: PropTypes.object,
    formProperties: PropTypes.object,
    //formData: PropTypes.object,
    formStore: PropTypes.object,
    B2CSettings: PropTypes.object,
    ClientApp: PropTypes.object,
    formSubmission: PropTypes.func,
    previousPageLink: PropTypes.string,
    submitText: PropTypes.string,
    nextText: PropTypes.string,
    //cancelHeading: PropTypes.string,
    //cancelText: PropTypes.string,
    returnFunction: PropTypes.func,
    saveDraft: PropTypes.func,
    hasStepNavigation: PropTypes.bool,
    showDraftMangement: PropTypes.bool,
    backurl: PropTypes.string
};

Step.defaultProps = {
    showback: true,
    submitText: 'Submit',
    nextText: 'Next',
    cancelHeading: 'Cancel application',
    cancelText: 'If you leave this application it will be cancelled. Are you sure you want to cancel?',
    hasStepNavigation: true,
    showDraftMangement: true
};

const mapStateToProps = (state) => {
    return {
        envdata: state.envdata,
        formProperties: getFormPropertiesSelector(state.formStore),
        //formData: getFormDataSelector(state.formStore),
        formStore: state.formStore,
        B2CSettings: state.B2CSettings,
        ClientApp: state.ClientApp
    }
}

export default connect(mapStateToProps)(withRouter(Step));